import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useCopyToClipboard } from '@rossum/components/copy-to-clipboard/useCopyToClipboard';
import { IconCopy, IconDotsVertical } from '@rossum/ui/icons/tabler';
import {
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from '@rossum/ui/material';
import { RowIcon } from './RowIcon';

type ActivityBlockMenuProps = {
  requestIds: string[];
};

export const ActivityBlockMenu = ({ requestIds }: ActivityBlockMenuProps) => {
  const intl = useIntl();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const { copyToClipboard } = useCopyToClipboard(requestIds.join(', '));

  if (requestIds.length === 0) return null;

  const copyRequestIds = () => {
    setAnchorEl(null);
    copyToClipboard();
  };

  return (
    <>
      <IconButton
        size="medium"
        color="secondary"
        onClick={e => setAnchorEl(e.currentTarget)}
        data-cy="document-history-block-menu-button"
      >
        <RowIcon icon={IconDotsVertical} />
      </IconButton>
      <Menu
        open={!!anchorEl}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={copyRequestIds}
          data-cy="document-history-copy-request-id"
        >
          <Stack
            direction="row"
            spacing={1}
            useFlexGap
            sx={{ alignItems: 'center' }}
          >
            <RowIcon icon={IconCopy} />
            <Typography>
              {intl.formatMessage(
                { id: 'features.documentHistory.action.copyRequestId' },
                { count: requestIds.length }
              )}
            </Typography>
          </Stack>
        </MenuItem>
      </Menu>
    </>
  );
};
